import React from 'react';
import './CartColumns.css'

const CartColumns = () => {
    return (
        <div>
            <div className="container">
                <div className="row cart-columns">
                    <div className="col-10  mx-auto col-lg-2 align-items-center text-center">
                        <h5>Products</h5>
                    </div>
                    <div className="col-10  mx-auto col-lg-2 align-items-center text-center">
                        <h5>Name</h5>
                    </div>
                    <div className="col-10  mx-auto col-lg-2 align-items-center text-center">
                        <h5>Price</h5>
                    </div>
                    <div className="col-10  mx-auto col-lg-2 align-items-center text-center">
                        <h5>Quantity</h5>
                    </div>
                    <div className="col-10  mx-auto col-lg-2 align-items-center text-center">
                        <h5>Remove</h5>
                    </div>
                    <div className="col-10  mx-auto col-lg-2 align-items-center text-center">
                        <h5>Total</h5>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CartColumns;
